(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('IntrumentoRelacionado', IntrumentoRelacionado);

    IntrumentoRelacionado.$inject = ['$resource'];

    function IntrumentoRelacionado ($resource) {
        var resourceUrl =  'api/intrumento-relacionados/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
